import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService, dropdownItems } from 'src/app/services/util.service';
import { aFuncionalButtons, ametadatatable } from 'src/app/shared/componentes/a-table/domain/a.table.interface';
import { ametadatatreetable, atreetableoptions } from 'src/app/shared/componentes/a-treetable/domain/a-treetable.interface';
import { ATreetableComponent } from 'src/app/shared/componentes/a-treetable/presentacion/a-treetable/a-treetable.component';
import { PricingRepository } from '../../../services/pricing.repository';
import { PRI_ActivarDesactivarTarifaRequest, PRI_ListarTarifaPorTipoServicioRequest, PRI_MantenimientoTarifaRequest, PRI_Tarifa_Cab, PRI_Tarifa_Det, PRI_Tarifa_Det_Recargo, getDetailZonaRutaRequest, listarauditoriaRequest } from '../../domain/tarifario-sli.request';
import { PricingService } from '../../../services/pricing.service';
import { parametrosRepository } from 'src/app/parametros/servicio/parametros.repository';
import { ObtenerParametrosRequest, listarEntidadesRequest, listarPuertosRequest } from 'src/app/parametros/domain/parametros.request';
import { BandejaTarifarioSliValidator } from '../../validaciones/bandeja-tarifario-sli.validator';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { D_validarTipoCambioRequest } from 'src/app/comercial/orden-venta/domain/request/comercial-orden-venta-request';
import { MessageService } from 'primeng/api';
import { CommonModule, Location } from '@angular/common';
import * as XLSX from 'xlsx';
import { ChangeDetectorRef } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { COD_ROLES } from 'src/app/shared/constantes/constantes';
import { valueOrDefault } from 'chart.js/dist/helpers/helpers.core';
import { Title } from '@angular/platform-browser';
import { RolesSesionService } from 'src/app/services/roles-sesion.service';

@Component({
  selector: 'app-bandeja-tarifario-sli',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FloatLabelModule,
    SelectModule,
    ButtonModule,
    ATreetableComponent,
    DialogModule,
    CheckboxModule,
    SharedModule,
    TableModule,
    RouterModule

  ],
  providers: [
    { provide: PricingRepository, useClass: PricingService },
    BandejaTarifarioSliValidator
  ],
  templateUrl: './bandeja-tarifario-sli.component.html',
  styleUrl: './bandeja-tarifario-sli.component.css'
})
export class BandejaTarifarioSliComponent {

  analg_costos: string = COD_ROLES.analg_costos;
  gerente_log: string = COD_ROLES.ger_log;

  constructor(
    private readonly storage: StorageService,
    private readonly util: UtilService,
    private readonly servPricing: PricingRepository,
    private readonly servParametros: parametrosRepository,
    private readonly validator: BandejaTarifarioSliValidator,
    private readonly servComercial: ComercialRepository,
    private readonly servMessage: MessageService,
    private readonly location: Location,
    private cdr: ChangeDetectorRef,
    private readonly title: Title,
    private readonly rolesService: RolesSesionService,
  ) {

    this.title.setTitle('Tarifario SLI');

    const request_tipo_cambio = <D_validarTipoCambioRequest>{}
    //request_tipo_cambio.scot_fechaoperacion = new Date()

    const hoy = new Date();
    const fechaSoloDia = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
    request_tipo_cambio.scot_fechaoperacion = fechaSoloDia
    servComercial.getTipoCambio(request_tipo_cambio).subscribe(response => {
      if (response.datos.status === 200) {
        this.tipoCambio.compra = response.datos.result[0].tipc_compra
        this.tipoCambio.venta = response.datos.result[0].tipc_venta
      }
    }, errorService => {
      servMessage.add({ summary: "Tipo de cambio", detail: "Es necesario que exista un tipo de cambio registrado para mostrar la pagina.", life: 3000, severity: "warn" })
      location.back()
      return
    })


    const request = <ObtenerParametrosRequest>{}
    request.codigos = [
      { codigo: "RGM" },
      { codigo: "FLE" },
      { codigo: "VIA" },
      { codigo: "OVE" },
      { codigo: "DISTRITO(PROV)" },
      { codigo: "TFA" },
      { codigo: "RUTAS" },
      { codigo: "CTR" },
      { codigo: "TRF" },
    ]
    this.servParametros.ObtenerParametros(request).subscribe(response => {
      if (response.datos.status === 200) {

        this.listRegimen = response.datos.result["RGM"]
        this.listCondicion = response.datos.result["FLE"]
        this.listVia = response.datos.result["VIA"]
        this.listDistritos = response.datos.result["DISTRITO(PROV)"]
        this.listTipoTarifa = response.datos.result["TFA"]
        this.listRutas = response.datos.result["RUTAS"]
        this.listTipoCarga = response.datos.result["CTR"]
        this.listTraficos = response.datos.result["TRF"]

        this.metadatatable[5].itemSelect = this.listCondicion
        this.metadatatable[6].itemSelect = this.listRegimen
        this.metadatatable[7].itemSelect = this.listTipoCarga

      }
    })

  }

  listTipoTarifa: dropdownItems[] = []
  listEstados: dropdownItems[] = [
    { label: "ACTIVO", value: "activo" },
    { label: "INACTIVO", value: "inactivo" },
    { label: "TODOS", value: "todos" }
  ]

  listRegimen: dropdownItems[] = []
  listCondicion: dropdownItems[] = []
  listVia: dropdownItems[] = []
  listDistritos: dropdownItems[] = []
  listRutas: dropdownItems[] = []
  listTipoCarga: dropdownItems[] = []
  listTraficos: dropdownItems[] = []

  tipoCambio: { compra: number, venta: number }
  addRow: boolean = false
  editRowPrincipal: boolean = false
  rol: string = '0'
  ngOnInit() {

    this.tipoCambio = { compra: 0, venta: 0 }
    this.getParametrosAsync()
    this.ngOnInitForm()

    this.rolesService.getRoles();
    const roles = this.rolesService.getRoles();
    const currentRol = this.storage.get("rol");
    const rolesPermitidos = ["1", String(this.analg_costos), String(this.gerente_log)];

    if (!rolesPermitidos.includes(currentRol)) {
      const rolEncontrado = roles.find(r => rolesPermitidos.includes(String(r.role_codigo)));

      if (rolEncontrado) {
        this.rol = String(rolEncontrado.role_codigo);
      } else {
        this.rol = currentRol;
      }

    } else {
      this.rol = currentRol;
    }

    this.rowFatherFunctions = [
      { icon: "pi pi-times", severity: "danger", function: (row) => this.enableDisableRow(row), pTooltip: "Desactivar", disabled: (row) => !row.ctar_estado, visible: (row) => ["1061", "1050", "1"].includes(this.rol) ? true : false },
      { icon: "pi pi-save", severity: "primary", function: (row) => this.operationByStatusTable(row), validateChanges: true, pTooltip: "Guardar", visible: (row) => ["1061", "1050", "1"].includes(this.rol) ? true : false },
      { icon: "pi pi-clone", severity: "warn", function: (row) => this.cloneTariff(row, this.datatablaTarifa), pTooltip: "Clonar" },
      { icon: "pi pi-trash", severity: 'danger', visible: (row) => ["1061", "1050", "1"].includes(this.rol) ? true : row.statustable === 'I', function: (row) => this.eliminarFila(row) },
      { icon: "pi pi-user", severity: "warn", function: (row) => this.verauditoria(row, 'ATC'), pTooltip: "Auditoria" },
      { icon: "pi pi-excel", severity: "warn", function: (row) => this.exportarexcel(row), pTooltip: "Exportar" }
    ]

    if (this.rol === this.analg_costos) {
      this.addRow = true
    }
  }

  optionTable: atreetableoptions = {
    children: {
      caption: {
        buttons: [
          { icon: "pi pi-file-import", severity: "info", pTooltip: "Importar", functionRow: (row) => this.importDetailByTypeService(row) },
          { icon: "pi pi-dollar", severity: "info", pTooltip: "Asignar Profit", functionRow: (row) => this.verpopupprofit(row) }
        ]
      }
    }
  }

  group: FormGroup
  groupprofit: FormGroup
  ngOnInitForm() {
    this.group = new FormGroup({
      tipo: new FormControl(null, Validators.required),
      estado: new FormControl("activo", null),
      pprofit: new FormControl(null, null)
    })

    this.groupprofit = new FormGroup({
      profit: new FormControl('0', null),
      tipoprofitmoneda: new FormControl("002", null)

    })

    this.groupadicionales = new FormGroup({
      observaciones: new FormControl('', null),


    })
  }

  rowFatherFunctions: aFuncionalButtons[] = [
  ]

  popUpAuditoriaChangeControl: any
  dt_auditoriaServChangeControl: any
  //mt_auditoriaServChangeControl:any
  custombAudiServChangeControl: any




  mt_auditoriaServChangeControl: newmetadate[] = [];


  verauditoria(row, tipo) {

    this.popUpAuditoriaChangeControl = true




    const request = <listarauditoriaRequest>{}

    if (tipo == 'ATC') {
      request.tipo = tipo
      request.codigo1 = row.ctar_codigo


      this.mt_auditoriaServChangeControl = [
        { title: 'AUDI Codigo', field: 'audI_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Tipo', field: 'audI_Tipo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI IPAddress', field: 'audI_IPAddress', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI MachineName', field: 'audI_MachineName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI ApplicationName', field: 'audI_ApplicationName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI LoginName', field: 'audI_LoginName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Usuario', field: 'audI_Usuario', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Fecha', field: 'audI_Fecha', filterType: 'date', inputType: 'date', style: { justify: 'left' } },
        { title: 'CTAR Codigo', field: 'ctaR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'CTAR Descripcion SPA', field: 'ctaR_Descripcion_SPA', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'CTAR Descripcion ENG', field: 'ctaR_Descripcion_ENG', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'CTAR Vigente Desde', field: 'ctaR_VigenteDesde', filterType: 'date', inputType: 'date', style: { justify: 'left' } },
        { title: 'CTAR Vigente Hasta', field: 'ctaR_VigenteHasta', filterType: 'date', inputType: 'date', style: { justify: 'left' } },
        { title: 'CTAR Profit Local', field: 'ctaR_ProfitLocal', filterType: 'text', inputType: 'text', style: { justify: 'right' } },
        { title: 'CTAR Observacion', field: 'ctaR_Observacion', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'CONS TabRGM', field: 'conS_TabRGM', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS CodRGM', field: 'conS_CodRGM', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS TabVIA', field: 'conS_TabVIA', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS CodVIA', field: 'conS_CodVIA', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS TabTCO', field: 'conS_TabTCO', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS CodTCO', field: 'conS_CodTCO', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO TabMND', field: 'tipO_TabMND', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO CodMND', field: 'tipO_CodMND', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CTAR Matriz', field: 'ctaR_Martiz', filterType: 'boolean', inputType: 'checkbox', style: { justify: 'center' } },
        { title: 'EMPR Codigo', field: 'empR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'SUCR Codigo', field: 'sucR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO TabTAR', field: 'tipO_TabTAR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO CodTAR', field: 'tipO_CodTAR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO TabTPR', field: 'tipO_TabTPR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO CodTPR', field: 'tipO_CodTPR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CTAR Codigo Padre', field: 'ctaR_CodigoPadre', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'CTAR Estado', field: 'ctaR_Estado', filterType: 'boolean', inputType: 'checkbox', style: { justify: 'center' } },
        { title: 'AUDI UsrCrea', field: 'audI_UsrCrea', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI FecCrea', field: 'audI_FecCrea', filterType: 'date', inputType: 'date', style: { justify: 'left' } },
        { title: 'AUDI UsrMod', field: 'audI_UsrMod', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI FecMod', field: 'audI_FecMod', filterType: 'date', inputType: 'date', style: { justify: 'left' } },
        { title: 'CONS TabFLE', field: 'conS_TabFLE', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'CONS CodFLE', field: 'conS_CodFLE', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'ENTC Codigo', field: 'entC_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'TIPO TabCTR', field: 'tipO_TabCTR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'TIPO CodCTR', field: 'tipO_CodCTR', filterType: 'text', inputType: 'text', style: { justify: 'center' } },
        { title: 'PUER Codigo', field: 'pueR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } }
      ]
    }

    else if (tipo == 'ATR') {
      request.tipo = tipo
      request.codigo1 = row.children?.dtar_codigo


      this.mt_auditoriaServChangeControl = [
        { title: 'AUDI Codigo', field: 'audI_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Tipo', field: 'audI_Tipo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI IPAddress', field: 'audI_IPAddress', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI MachineName', field: 'audI_MachineName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI ApplicationName', field: 'audI_ApplicationName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI LoginName', field: 'audI_LoginName', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Usuario', field: 'audI_Usuario', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI Fecha', field: 'audI_Fecha', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR Codigo', field: 'rtaR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'DTAR Codigo', field: 'dtaR_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RECO Codigo', field: 'recO_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RECO DESCRIPCION', field: 'recO_Descripcion', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR ValueCosto', field: 'rtaR_ValueCosto', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR ValueVenta', field: 'rtaR_ValueVenta', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR TablaReferencia', field: 'rtaR_TablaReferencia', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'TIPO TabMND', field: 'tipO_TabMND', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'TIPO CodMND', field: 'tipO_CodMND', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'TIPO TabTCN', field: 'tipO_TabTCN', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'TIPO CodTCN', field: 'tipO_CodTCN', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'SERV Codigo', field: 'serV_Codigo', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI UsrCrea', field: 'audI_UsrCrea', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI FecCrea', field: 'audI_FecCrea', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI UsrMod', field: 'audI_UsrMod', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'AUDI FecMod', field: 'audI_FecMod', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR ValueDescripcion', field: 'rtaR_ValueDescripcion', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR CodigoInterno', field: 'rtaR_CodigoInterno', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR TipoTab', field: 'rtaR_TipoTab', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR TipoCod', field: 'rtaR_TipoCod', filterType: 'text', inputType: 'text', style: { justify: 'left' } },
        { title: 'RTAR Profit', field: 'rtaR_Profit', filterType: 'text', inputType: 'text', style: { justify: 'left' } }
      ]


    }



    this.servPricing.listarauditoria(request).subscribe(response => {

      if (response.datos.status === 200) {
        this.dt_auditoriaServChangeControl = response.datos.result;




        // let mt_auditoriaServChangeControl: newmetadate [] = [
        //   { title: 'Ejcutivo', field: 'ejecutivo', filterType: 'text', inputType: 'text',style: { justify: 'left' }},
        //   { title: 'Cliente', field: 'cliente', filterType: 'text', inputType: 'text',style: { justify: 'left' }},
        //   { title: 'Condición', field: 'condicion', filterType: 'text', inputType: 'text'},
        //   { title: 'Medio de pago', field: 'mediopago', filterType: 'text', inputType: 'text'},
        // ]



        // listadoauditoria.forEach(r => {




        //   const metadata = []
        //   r.metadata.forEach(r => {

        //     const item: ametadatatable = {

        //       field: {
        //         input: ((r.tipo_desinp === 'select' || r.tipo_desinp === 'selectByType') ? r.reco_codigo.toString() + '_codigointerno' : r.reco_codigo.toString() + '_value'),
        //         output: r.activalabel === 0 ? r.reco_codigo.toString() + '_value' : r.reco_codigo.toString() + '_label',
        //         coin: r.reco_codigo.toString() + '_tipomoneda'
        //       },
        //       header: { title: r.reco_descripcion, filter: true, sort: true, type: "row" },
        //       type: r.tipo_desinp,
        //       itemSelect: this.getParametrosByType(r.reco_lista),
        //       function: (r.reco_codigo.toString() === '23' ? (row) => this.validator.calculateCosto(row, this.tipoCambio) : (r.reco_codigo.toString() === '15' ? (row) => this.validator.validateCosto(row, this.tipoCambio) : null)), //(row) => this.calculateCosto(row),
        //       onChange: (r.reco_codigo.toString() === '3' ? (row) => this.validator.validateServicio(row) : (r.reco_codigo.toString() === '30' ? (row) => this.getEntidadesByType(row) : null)),
        //       readonly: (r.reco_codigo.toString() === '16' || (r.reco_codigo.toString() === '15' && this.rol !== "8") ? true : false),
        //       visible: ((this.rol === "8" && (r.reco_codigo.toString() === '23' || r.reco_codigo.toString() === '16')) ? true : false),
        //       buttonsHeader: (r.reco_codigo.toString() === '45' ? [{ icon: "pi pi-sync", severity: "primary", pTooltip: "Sincronizar rutas", functionRow: (row) => this.syncRutas(row) }] : []),
        //       buttonsBody: (r.reco_codigo.toString() === '45' ? [{ icon: "pi pi-eye", severity: "primary", pTooltip: "Ver detalle", functionRow: (row) => this.viewDetail(row, 'RUTA') }] : [])
        //     }

        //     metadata.push(item)

        //   })


        // this.datatablaTarifa = Array.from(this.datatablaTarifa)


        this.servMessage.add({ summary: "Buscar tarifas.", detail: `Se encontraron ${response.datos.totalRegistros} tarifas.`, severity: "success" })
      }
    }, (errorService) => {
      this.servMessage.add({ summary: "Buscar Tarifas.", detail: `${errorService.error.meta.mensaje}`, severity: "warn" })

    })





  }

  aceptarPopUpDocumento() {

    this.popUpAuditoriaChangeControl = false

  }

  manejoPopUpDocumentos(a, b) {

  }


  eliminarFila(row) {
    console.log(row)

    const index = this.datatablaTarifa.findIndex(r => r.codeinterno === row.codeinterno);
    if (index !== -1) {
      this.datatablaTarifa.splice(index, 1);
    }
  }

  rowChildrenFunctions: aFuncionalButtons[] = [
    { icon: "pi pi-clone", severity: "info", function: (row) => this.cloneDetailTariff(row, this.datatablaTarifa), pTooltip: "Clonar" },
    { icon: "pi pi-user", severity: "warn", function: (row) => this.verauditoria(row, 'ATR'), pTooltip: "Auditoria" }

  ]

  ListaPuertos: any[] = []
  Entidades: any[] = []
  metadatatable: ametadatatreetable[] = [
    { field: { output: "ctar_descripcion_spa", input: "ctar_descripcion_spa" }, header: { title: "Descripción", filter: true, sort: true, type: "row" }, type: "text" },


    //  buttonsBody: (r.reco_codigo.toString() === '45' ? [{ icon: "pi pi-eye", severity: "primary", pTooltip: "Ver detalle", functionRow: (row) => this.viewDetail(row, 'RUTA') }] : [])

    { field: { output: "entc_razonsocial", input: "entc_codigo" }, header: { title: "Entidad", filter: true, sort: true, type: "row" }, type: "select", itemSelect: this.Entidades },
    { field: { output: "ctar_vigentedesde", input: "ctar_vigentedesde" }, header: { title: "Vigente Desde", filter: true, sort: true, type: "row" }, type: "date" },
    { field: { output: "ctar_vigentehasta", input: "ctar_vigentehasta" }, header: { title: "Vigente Hasta", filter: true, sort: true, type: "row" }, type: "date", onChanges: (row) => this.validator.validateEndDate(row) },
    { field: { output: "ctar_estado", input: "ctar_estado" }, header: { title: "Estado", filter: true, sort: true, type: "row" }, type: "checkbox" },
    { field: { output: "cons_desfle", input: "cons_codfle" }, header: { title: "Condición", filter: true, sort: true, type: "row" }, type: "select", itemSelect: this.listCondicion },
    { field: { output: "cons_desrgm", input: "cons_codrgm" }, header: { title: "Regimen", filter: true, sort: true, type: "row" }, type: "select", itemSelect: this.listRegimen },
    {
      field: { output: "tipo_desctr", input: "tipo_codctr" },
      header: { title: "Tipo de equipo", filter: true, sort: true, type: "row" },
      type: "select",
      itemSelect: this.listTipoCarga
    },
    {
      field: { output: "puer_nombre", input: "puer_codigo" },
      header: { title: "Puerto", filter: true, sort: true, type: "row" },
      type: "select",
      itemSelect: this.ListaPuertos
    },
    {
      field: { output: "ctar_observacion", input: "ctar_observacion" }, header: { title: "Comentarios", filter: true, sort: true, type: "row" }, type: "button",
      button:
        [{
          icon: 'pi pi-eye',
          label: '',
          //function?: () => void
          // function: () => this.validator.validateEndDate(row),
          severity: 'primary',
          pTooltip: 'ver detalle',
          //disabled?: (row: any) => boolean
          //validateChanges?: boolean
          // variant?: "outlined" | "text"
          //functionRow?: (row) => void
          functionRow: (row) => this.viewobservaciones(row)
        }]
    }
  ]

  operationByStatusTable(row: any): void {

    if (row.statustable === 'I') {
      this.saveTariff(row)
    } else {
      this.editTariff(row)
    }

  }

  cloneTariff(row: any, table: any) {

    var newRow = this.util.deepClone(row)

    const usedCodes = table.map(r => r.codeinterno)

    let newCode = 0
    while (usedCodes.includes(newCode)) {
      newCode++
    }

    newRow.codeinterno = newCode
    newRow.statustable = 'I'
    newRow.checked = false

    newRow.detail?.map(r => {

      for (const key in r) {
        if (key.includes("codigo") && !key.includes("codigointerno") && !key.includes("serv_codigo")) {
          r[key] = null;
        }
      }

      // r["16_value"] = null
      // r["16_tipomoneda"] = null

      // r["23_value"] = null
      // r["23_tipomoneda"] = null

      r.statustable = 'I'
      r.checked = false

    })

    console.log('filaoriginal', row)
    console.log('filaclonada', newRow)



    const valid = newRow.metadata.find(e => e.type === "selectByType")
    if (valid) {
      newRow.detail.forEach(e => {
        this.getEntidadesByType({ "father": { codeinterno: newRow.codeinterno }, "children": { codeinterno: e.codeinterno, '30_codigointerno': e['30_codigointerno'], '31_codigointerno': e['31_codigointerno'] } })
      })
    }



    table.push(newRow)
  }

  cloneDetailTariff(row: any, table: any) {

    var newRow = this.util.deepClone(row.children)

    const usedCodes = row.father.detail.map(r => r.codeinterno)

    let newCode = 0
    while (usedCodes.includes(newCode)) {
      newCode++
    }

    for (const key in newRow) {
      if (key.includes("codigo") && !key.includes("codigointerno") && !key.includes("serv_codigo")) {
        newRow[key] = null;
      }
    }

    // newRow["16_value"] = null
    // newRow["16_tipomoneda"] = null

    // newRow["23_value"] = null
    // newRow["23_tipomoneda"] = null

    newRow.codeinterno = newCode
    newRow.statustable = 'I'
    newRow.checked = false

    row.father.detail.push(newRow)
  }



  importDetailByTypeService(row: any): void {

    if (!row.entc_codigo || row.entc_codigo === "") {
      this.servMessage.add({ summary: "Ingresar Proveedor.", detail: "Para poder importar el archivo necesita seleccionar un proveedor.", severity: "warn" })
      return
    }

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xlsx, .xls';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        const newExcelData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        const detalle = []

        if (this.group.value.tipo === '002') {


          newExcelData.forEach(r => {

            const item = {
              "3_codigo": 1649,
              "3_value": null,
              "3_label": "SERVICIO DE TRANSPORTE LOCAL                                          ",
              "3_recargo": 3,
              "3_tipomonto": " ",
              "3_tipomoneda": null,
              "3_codigointerno": "732",

              "17_codigo": 1650,
              "17_value": null,
              "17_label": row.entc_razonsocial,
              "17_recargo": 17,
              "17_tipomonto": " ",
              "17_tipomoneda": null,
              "17_codigointerno": row.entc_codigo.toString(),

              "27_codigo": 1651,
              "27_value": null,
              "27_label": "CALLAO",
              "27_recargo": 27,
              "27_tipomonto": " ",
              "27_tipomoneda": null,
              "27_codigointerno": "070101",

              "14_codigo": 1652,
              "14_value": null,
              "14_label": r["DISTRITO"].toUpperCase(),
              "14_recargo": 14,
              "14_tipomonto": " ",
              "14_tipomoneda": null,
              "14_codigointerno": r["ID DISTRITO"],

              "9_codigo": 1653,
              "9_value": null,
              "9_label": "CONTENEDOR",
              "9_recargo": 9,
              "9_tipomonto": " ",
              "9_tipomoneda": null,
              "9_codigointerno": "002",
              "25_codigo": 1654,
              "25_value": null,
              "25_label": "DRY",
              "25_recargo": 25,
              "25_tipomonto": " ",
              "25_tipomoneda": null,
              "25_codigointerno": "002",
              "15_codigo": 1655,
              "15_value": r["MONTO"],
              "15_label": "",
              "15_recargo": 15,
              "15_tipomonto": "C",
              "15_tipomoneda": (r["MONEDA"] === "SOLES" ? "001" : "002"),
              "15_codigointerno": null,

              "23_codigo": 1656,
              "23_value": null,
              "23_label": "",
              "23_recargo": 23,
              "23_tipomonto": " ",
              "23_tipomoneda": null,
              "23_codigointerno": null,

              "16_codigo": 1657,
              "16_value": null,
              "16_label": "",
              "16_recargo": 16,
              "16_tipomonto": "V",
              "16_tipomoneda": null,
              "16_codigointerno": null,

              "dtar_codigo": 188,
              "serv_codigo": 732,
              "profit_minimo": 90,
              "moneda": "002",
              "tipo_profit": "001",

              "codeinterno": 1,
              "statustable": "E",
              "checked": false
            }
            detalle.push(item)
          })

          if (detalle.length > 0) {
            if (Array.isArray(row.detail)) {
              row.detail.push(...detalle); // <-- desestructura para evitar array dentro de array
            } else {
              row.detail = [...detalle]; // crea una copia nueva del array
            }
          }

        } else if (this.group.value.tipo === '003') {

          newExcelData.forEach(r => {
            const item = {
              "3_codigo": 1610,
              "3_value": null,
              "3_label": "ALMACEN",
              "3_recargo": 3,
              "3_tipomonto": " ",
              "3_tipomoneda": null,
              "3_codigointerno": "1026",
              "1_codigo": 1611,
              "1_value": null,
              "1_label": row.entc_razonsocial,
              "1_recargo": 1,
              "1_tipomonto": " ",
              "1_tipomoneda": null,
              "1_codigointerno": row.entc_codigo,
              "2_codigo": 1612,
              "2_value": null,
              "2_label": r["TERMINAL PORTUARIO"],
              "2_recargo": 2,
              "2_tipomonto": " ",
              "2_tipomoneda": null,
              "2_codigointerno": r["CODIGO TERMINAL"],
              "9_codigo": 1613,
              "9_value": null,
              "9_label": "CONTENEDOR",
              "9_recargo": 9,
              "9_tipomonto": " ",
              "9_tipomoneda": null,
              "9_codigointerno": "002",
              "12_codigo": 1614,
              "12_value": "5",
              "12_label": "",
              "12_recargo": 12,
              "12_tipomonto": " ",
              "12_tipomoneda": null,
              "12_codigointerno": null,
              "13_codigo": 1615,
              "13_value": null,
              "13_label": r["TIPO TARIFA"],
              "13_recargo": 13,
              "13_tipomonto": " ",
              "13_tipomoneda": null,
              "13_codigointerno": r["CODIGO TIPO TARIFA"],
              "26_codigo": 1616,
              "26_value": null,
              "26_label": r["TIPO CNT"],
              "26_recargo": 26,
              "26_tipomonto": " ",
              "26_tipomoneda": null,
              "26_codigointerno": r["CODIGO TIPO CNT"],
              "15_codigo": 1617,
              "15_value": r["MONTO"],
              "15_label": "",
              "15_recargo": 15,
              "15_tipomonto": "C",
              "15_tipomoneda": (r["MONEDA"] === "SOLES" ? "001" : "002"),
              "15_codigointerno": null,
              "23_codigo": 1618,
              "23_value": null,
              "23_label": "",
              "23_recargo": 23,
              "23_tipomonto": " ",
              "23_tipomoneda": null,
              "23_codigointerno": null,
              "16_codigo": 1619,
              "16_value": null,
              "16_label": "",
              "16_recargo": 16,
              "16_tipomonto": "V",
              "16_tipomoneda": null,
              "16_codigointerno": null,
              "28_codigo": 1732,
              "28_value": r["DIAS LIBRES"],
              "28_label": "",
              "28_recargo": 28,
              "28_tipomonto": " ",
              "28_tipomoneda": null,
              "28_codigointerno": null,
              "29_codigo": 1809,
              "29_value": r["LINEA CREDITO"],
              "29_label": "",
              "29_recargo": 29,
              "29_tipomonto": " ",
              "29_tipomoneda": (r["MONEDA LINEA CREDITO"] ? (r["MONEDA LINEA CREDITO"] === "SOLES" ? "001" : "002") : null),
              "29_codigointerno": null,
              "dtar_codigo": 184,
              "serv_codigo": 1026,
              "profit_minimo": 100,
              "moneda": "002",
              "tipo_profit": "001",
              "codeinterno": 0,
              "statustable": "E",
              "checked": false
            }
            detalle.push(item)
          })

          if (detalle.length > 0) {
            if (Array.isArray(row.detail)) {
              row.detail.push(...detalle); // <-- desestructura para evitar array dentro de array
            } else {
              row.detail = [...detalle]; // crea una copia nueva del array
            }
          }

        }

      };

      reader.readAsArrayBuffer(file);
    };

    fileInput.click();

  }

  listaFiltrada: { [key1: number]: { [key2: number]: dropdownItems[] } } = {};
  getEntidadesByType(row) {
    console.log(row)
    const padreCodigo = parseInt(row.father?.codeinterno);
    const hijoCodigo = parseInt(row.children?.codeinterno);
    const request = <listarEntidadesRequest>{
      entc_codigo: null,
      tipe_codigo: parseInt(row.children["30_codigointerno"])
    }
    this.servParametros.listarEntidades(request).subscribe(response => {
      // console.log(response)
      // this.listaFiltrada[row.father.codeinterno][row.children.codeinterno] = response.datos.result?.map(r => ({ label: r.nombre, value: r.codigo }))

      const dropdownItems = response?.datos?.result?.map((r: any) => ({
        label: r.nombre,
        value: r.codigo.toString()
      })) || [];

      // Inicializar el primer nivel si no existe
      if (!this.listaFiltrada[padreCodigo]) {
        this.listaFiltrada[padreCodigo] = {};
      }

      // Asignar los dropdown items al segundo nivel
      this.listaFiltrada[padreCodigo][hijoCodigo] = dropdownItems;

      console.log(this.listaFiltrada);


      const agregado = dropdownItems.find(e => e.value === row.children["31_codigointerno"])

      if (!agregado) {
        row.children["31_codigointerno"] = null
        row.children["31_label"] = null
      }

    })
    console.log(this.listaFiltrada)
  }


  functionOnInitTable() {
    console.log(this.metadatatable)
    console.log(this.datatablaTarifa)

    this.listaFiltrada = {};

    this.datatablaTarifa.forEach(r => {

      const valid = r.metadata.find(e => e.type === "selectByType")
      if (valid) {
        r.detail.forEach(e => {
          this.getEntidadesByType({ "father": { codeinterno: r.codeinterno }, "children": { codeinterno: e.codeinterno, '30_codigointerno': e['30_codigointerno'], '31_codigointerno': e['31_codigointerno'] } })
        })
      }
    })


  }

  datatablaTarifa: any[] = []
  search(): void {

    if (!this.group.valid) {
      this.group.markAllAsTouched();
      return
    }

    if (this.group.value.tipo === '001') {
      const exists = this.metadatatable.some(r => r.field.output === "tipo_desctr");
      if (!exists) {
        this.metadatatable.push({
          field: { output: "tipo_desctr", input: "tipo_codctr" },
          header: { title: "Tipo de equipo", filter: true, sort: true, type: "row" },
          type: "select",
          itemSelect: this.listTipoCarga
        });
      }
    } else {
      const index = this.metadatatable.findIndex(r => r.field.output === "tipo_desctr");
      if (index !== -1) {
        this.metadatatable.splice(index, 1);
      }
    }

    const loadingScreen = this.util.showLoadingScreen({ message: "Buscando datos..." });
    try {
      this.datatablaTarifa = []

      let rol = this.storage.get('rol')
      const request = <PRI_ListarTarifaPorTipoServicioRequest>{}
      request.tipo = this.group.value.tipo
      request.estado = this.group.value.estado
      request.roles = rol

      let isprofit = this.group.value.pprofit
      var istarifa = ""
      if (isprofit == true) {
        istarifa = "S"
      } else {
        istarifa = "T"
      }

      request.solosinprofit = istarifa
      this.servPricing.PRI_ListarTarifaPorTipoServicio(request).subscribe(response => {

        if (response.datos.status === 200) {
          const tarifas = response.datos.result

          tarifas.forEach(r => {

            const metadata = []
            r.metadata.forEach(r => {

              const item: ametadatatable = {

                field: {
                  input: ((r.tipo_desinp === 'select' || r.tipo_desinp === 'selectByType') ? r.reco_codigo.toString() + '_codigointerno' : (r.tipo_desinp === 'text') ? r.reco_codigo.toString() + '_label' : r.reco_codigo.toString() + '_value'),
                  output: r.activalabel === 0 ? r.reco_codigo.toString() + '_value' : r.reco_codigo.toString() + '_label',
                  coin: r.reco_codigo.toString() + '_tipomoneda'
                },
                header: { title: r.reco_descripcion, filter: true, sort: true, type: "row" },
                type: r.tipo_desinp,
                itemSelect: this.getParametrosByType(r.reco_lista),
                function: (r.reco_codigo.toString() === '23' || r.reco_codigo.toString() === '15' ? (row) => this.validator.calculateCosto(row, this.tipoCambio, this.group.value.tipo) : (r.reco_codigo.toString() === '15' || r.reco_codigo.toString() === '23' ? (row) => this.validator.validateCosto(row, this.tipoCambio, this.group.value.tipo) : null)), //(row) => this.calculateCosto(row),
                onChange: (r.reco_codigo.toString() === '3' ? (row) => this.validator.validateServicio(row) : (r.reco_codigo.toString() === '30' ? (row) => this.getEntidadesByType(row) : null)),
                readonly: (r.reco_codigo.toString() === '16' || (r.reco_codigo.toString() === '15' && (this.rol !== this.analg_costos && this.rol !== '1' && this.rol !== this.gerente_log)) ? true : false),
                visible: this.validarcolumnavisible(r),
                buttonsHeader: (r.reco_codigo.toString() === '45' ? [{ icon: "pi pi-sync", severity: "primary", pTooltip: "Sincronizar rutas", functionRow: (row) => this.syncRutas(row) }] : []),
                buttonsBody: (r.reco_codigo.toString() === '45' ? [{ icon: "pi pi-eye", severity: "primary", pTooltip: "Ver detalle", functionRow: (row) => this.viewDetail(row, 'RUTA') }] : [])
              }

              metadata.push(item)

            })

            const item_cabecera = {
              ctar_codigo: r.ctar_codigo,
              ctar_descripcion_spa: r.ctar_descripcion_spa,
              ctar_descripcion_eng: r.ctar_descripcion_eng,
              ctar_vigentedesde: r.ctar_vigentedesde ? new Date(r.ctar_vigentedesde) : null,
              ctar_vigentehasta: r.ctar_vigentehasta ? new Date(r.ctar_vigentehasta) : null,
              ctar_profitlocal: r.ctar_profitlocal,
              ctar_observacion: r.ctar_observacion,
              cons_tabrgm: r.cons_tabrgm,
              cons_codrgm: r.cons_codrgm,
              cons_desrgm: r.cons_desrgm,
              cons_tabvia: r.cons_tabvia,
              cons_codvia: r.cons_codvia,
              cons_desvia: r.cons_desvia,
              cons_tabtco: r.cons_tabtco,
              cons_codtco: r.cons_codtco,
              cons_destco: r.cons_destco,
              cons_tabfle: r.cons_tabfle,
              cons_codfle: r.cons_codfle,
              cons_desfle: r.cons_desfle,
              tipo_tabmnd: r.tipo_tabmnd,
              tipo_codmnd: r.tipo_codmnd,
              tipo_desmnd: r.tipo_desmnd,
              ctar_matriz: r.ctar_matriz,
              empr_codigo: r.empr_codigo,
              sucr_codigo: r.sucr_codigo,
              tipo_tabtar: r.tipo_tabtar,
              tipo_codtar: r.tipo_codtar,
              tipo_destar: r.tipo_destar,
              tipo_tabtpr: r.tipo_tabtpr,
              tipo_codtpr: r.tipo_codtpr,
              tipo_destpr: r.tipo_destpr,
              ctar_codigopadre: r.ctar_codigopadre,
              ctar_estado: r.ctar_estado,
              detail: this.generateDataTarifa(r.detalle),
              metadata: metadata,
              entc_codigo: r.entc_codigo.toString(),
              entc_razonsocial: r.entc_razonsocial,
              tipo_tabctr: r.tipo_tabctr,
              tipo_codctr: r.tipo_codctr,
              tipo_desctr: r.tipo_desctr,
              puer_codigo: r.puer_codigo,
              puer_nombre: r.puer_nombre
            }
            item_cabecera.detail = this.util.setFormatTable(item_cabecera.detail)
            this.datatablaTarifa.push(item_cabecera)
          })

          this.datatablaTarifa = this.util.setFormatTable(this.datatablaTarifa)
          this.datatablaTarifa = Array.from(this.datatablaTarifa)

          console.log('datatable', this.datatablaTarifa)

          this.functionOnInitTable()

          loadingScreen.close()
          this.servMessage.add({ summary: "Buscar tarifas.", detail: `Se encontraron ${response.datos.totalRegistros} tarifas.`, severity: "success" })
        }
      }, (errorService) => {
        loadingScreen.close()
        this.servMessage.add({ summary: "Buscar ordenes de servicio.", detail: `${errorService.error.meta.mensaje}`, severity: "warn" })

      })
    } catch (error) {
      loadingScreen.close()
      console.error('Error al buscar tarifas:', error);
    }
  }


  validarcolumnavisible(r) {

    let opcion = false

    if (((this.rol !== this.analg_costos && this.rol !== COD_ROLES.admin && this.rol !== COD_ROLES.coord_log) && (r.reco_codigo.toString() === '23' || r.reco_codigo.toString() === '16')) == true) {
      opcion = true
    } else {
      opcion = false
    }

    if (((["4", "9", "15", "1029"].some(r => this.rol?.includes(r))) &&
      (r.reco_codigo.toString() === '15' || r.reco_codigo.toString() === '23' ||
        // Condiciones crédito & Línea de crédito
        r.reco_codigo.toString() === '28' || r.reco_codigo.toString() === '29')) == true) {
      opcion = true
    } else {
      opcion = false
    }

    return opcion
  }

  syncRutas(row) {
    console.log(row)
    const request = <ObtenerParametrosRequest>{}
    request.codigos = [
      { codigo: "RUTAS" }
    ]
    this.servParametros.ObtenerParametros(request).subscribe(response => {
      if (response.datos.status === 200) {

        this.listRutas = response.datos.result["RUTAS"]

        const item = row.metadata.find(r => r.field.input === "45_codigointerno")

        if (item) {
          item.itemSelect = response.datos.result["RUTAS"]
        }


        this.datatablaTarifa.forEach(r => {
          const item = r.metadata.find(e => e.field.input === "45_codigointerno")

          if (item) {
            item.itemSelect = response.datos.result["RUTAS"]
          }

        })
      }
    })

  }

  visible: boolean = false;
  detallePopUp: any[] = []
  viewDetail(row, tipo) {
    console.log(row)
    // row.event.stopPropagation()
    this.detallePopUp = []
    switch (tipo) {
      case "RUTA":
        const request_01 = <getDetailZonaRutaRequest>{}
        request_01.codigo = row.children['45_codigointerno']
        request_01.entidad = (this.group.value.tipo === "002" ? null : row.children['17_codigointerno'])
        request_01.zona = null
        request_01.tipo = 'RUTA'
        this.servPricing.getDetailZonaRuta(request_01).subscribe(response => {
          this.detallePopUp = response.datos.result
          this.visible = true
        })

        break;
      case "ZONA":
        const request_02 = <getDetailZonaRutaRequest>{}
        request_02.codigo = null
        request_02.entidad = row.father.entc_codigo
        request_02.zona = row.children['45_codigointerno']
        request_02.tipo = 'RUTA'
        this.servPricing.getDetailZonaRuta(request_02).subscribe(response => {
          this.detallePopUp = response.datos.result
          this.visible = true
        })

        break;
      default:
        break;
    }

    console.log(row)

  }

  generateDataTarifa(data): any[] {

    const newDataTarifa = []

    data.forEach(r => {

      const item = {};

      r.recargos.forEach(e => {

        item[e.reco_codigo.toString() + '_codigo'] = e.rtar_codigo
        item[e.reco_codigo.toString() + '_value'] = (e.reco_tipomonto === 'C' ? e.rtar_valuecosto : e.rtar_valueventa)
        item[e.reco_codigo.toString() + '_label'] = e.rtar_valuedescripcion
        item[e.reco_codigo.toString() + '_recargo'] = e.reco_codigo
        item[e.reco_codigo.toString() + '_tipomonto'] = e.reco_tipomonto
        item[e.reco_codigo.toString() + '_tipomoneda'] = e.tipo_codmnd
        item[e.reco_codigo.toString() + '_codigointerno'] = e.rtar_codigointerno
      })

      item["dtar_codigo"] = r.dtar_codigo
      item["serv_codigo"] = r.serv_codigo
      item["profit_minimo"] = r.profit_minimo
      item["moneda"] = r.moneda
      item["tipo_profit"] = r.tipo_profit

      newDataTarifa.push(item)

    })

    return newDataTarifa
  }

  listaServicios: any[] = []
  parametrosWeb: any
  async getParametrosAsync() {

    const loading = this.util.showLoadingScreen({ message: "Cargando tarifa" })
    try {
      this.parametrosWeb = await this.util.obtenerDatos([{ tipo: "TODOS" }])
      loading.close()
    } catch (e) {
      console.error(e);
    } finally {
      loading.close()
    }

    this.listaServicios = this.parametrosWeb.filter(r => r.tipo === "SERVICIO" && r.lineaNegocio === '003').map(r => ({ label: r.nombre, value: r.codigo }))

    this.Entidades = this.parametrosWeb.filter(r => r.tipo === "PROVEEDOR").map(r => ({ label: r.nombre, value: r.codigo }))


    const request = <listarPuertosRequest>{
      puer_codigo: null,
      puer_nombre: null
    }
    this.servParametros.listarPuertos(request).subscribe(response => {

      this.ListaPuertos = response.datos.result.map(r => {
        const tipoVia = r.via ? ' - ' + this.comparativoVia[r.via] || '' : '';
        return {
          label: r.nombre + (tipoVia ? ' ' + tipoVia : ''),
          value: parseInt(r.codigo)
        };
      });

      this.metadatatable[8].itemSelect = this.ListaPuertos
    })

    this.metadatatable[1].itemSelect = this.Entidades

  }

  comparativoVia: { [key: string]: string } = {
    "001": "MARÍTIMA",
    "002": "AÉREA",
    "003": "TERRESTRE",
    "004": "FLUVIAL"
  };

  getParametrosByType(tipo: string) {

    var parametros = []
    if (this.parametrosWeb) {

      if (tipo === 'DISTRITO(PROV)') {
        parametros = this.listDistritos
      } else if (tipo === 'RUTAS') {
        parametros = this.listRutas
      }
      else if (tipo === 'SERVICIO') {
        parametros = this.listaServicios//this.parametrosWeb.filter(r => r.tipo === tipo  && r.lineaNegocio === '003').map(r => ({ label: r.nombre, value: r.codigo }))
      } else if (tipo === 'TRAFICO') {
        parametros = this.listTraficos
      }
      else {
        parametros = this.parametrosWeb.filter(r => r.tipo === tipo).map(r => ({ label: r.nombre, value: r.codigo }))
      }

    }
    return parametros

  }

  listMatrizCode: { [key: string]: number } = {
    "001": 6,
    "002": 1,
    "003": 4,
    "004": 53,
    "005": 55,
    "006": 57,
    "007": 1033,
  };

  saveTariff(row: any): any {

    const data: any[] = row.detail
    const metadata = row.metadata

    if (data.length === 0) {
      this.util.ShowMessage({ mensaje: "Debe agregar al menos un servicio a la tarifa.", tipo: "warning" })
      return
    }

    if (this.rol === this.analg_costos && data.length > 0) {
      const validate = data.find(r => !r["15_value"] || r["15_value"] < 0)
      if (validate) {
        this.util.ShowMessage({ mensaje: "Todos los servicios agregados deben de tener un costo mayor o igual a cero.", tipo: "warning" })
        return
      }
    }

    const loadingScreen = this.util.showLoadingScreen({ message: "Guardando tarifa ..." })
    try {
      const request = <PRI_MantenimientoTarifaRequest>{}

      const detalle: PRI_Tarifa_Det[] = []
      const recargo: PRI_Tarifa_Det_Recargo[] = []
      data.forEach(r => {

        const item_detalle: PRI_Tarifa_Det = {
          codeinterno: r.codeinterno,
          ctar_codigo: 1,
          dtar_codigo: r.codeinterno,
          serv_codigo: r.serv_codigo,
          profit_minimo: r.profit_minimo,
          statustable: 'I'
        }

        const numbercolumns: any[] = []
        metadata.forEach(e => {
          const item_field = { field: e.field.input }
          numbercolumns.push(item_field)
        })

        numbercolumns.forEach(e => {

          const codigo = e.field.split('_')[0]

          const item_recargo: PRI_Tarifa_Det_Recargo = {
            rtar_codigo: 0,
            dtar_codigo: r.codeinterno,
            reco_codigo: codigo,
            rtar_valueventa: r[codigo + '_value'],
            serv_codigo: '1',
            rtar_valuedescripcion: r[codigo + '_label'],
            rtar_codigointerno: r[codigo + '_codigointerno'],
            tipo_codmnd: r[codigo + '_tipomoneda']
          }
          recargo.push(item_recargo)

        })

        detalle.push(item_detalle)
      })

      const cabecera: PRI_Tarifa_Cab[] = []
      const item: PRI_Tarifa_Cab = {
        ctar_codigo: 1,
        ctar_descripcion_spa: row.ctar_descripcion_spa,
        cons_codrgm: row.cons_codrgm,
        cons_codvia: row.cons_codvia,
        tipo_codmnd: row.tipo_codmnd,
        ctar_vigentedesde: row.ctar_vigentedesde,
        ctar_vigentehasta: row.ctar_vigentehasta,
        cons_codtco: row.cons_codtco,
        ctar_profitlocal: row.ctar_profitlocal,
        ctar_observacion: row.ctar_observacion,
        ctar_codigopadre: row.ctar_codigopadre == null ? this.listMatrizCode[this.group.value.tipo] : row.ctar_codigopadre, //row.ctar_codigopadre,
        ctar_estado: row.ctar_estado,
        ctar_matriz: false, //row.ismatriz ? true : false,
        empr_codigo: 1,
        sucr_codigo: 1,
        tipo_codtar: this.group.value.tipo,//row.tipo_codtar,
        tipo_codtpr: row.tipo_codtpr,
        cons_codfle: row.cons_codfle,
        entc_codigo: row.entc_codigo,
        tipo_codctr: row.tipo_codctr ?? null,
        puer_codigo: row.puer_codigo,
        codeinterno: 1,
        statustable: 'I',
        usuario: this.storage.get('usuario')
      }
      cabecera.push(item)

      request.cabecera = cabecera
      request.detalle = detalle
      request.recargo = recargo

      this.servPricing.PRI_MantenimientoTarifa(request).subscribe(response => {
        if (response.datos.status === 200) {
          loadingScreen.close();
          this.util.ShowMessage({ titulo: 'SUCCESSFUL', mensaje: "Operación realizada con exito.", tipo: 'ok' })
          this.search()
        }
      }, (errorServicio) => {
        loadingScreen.close();
        const mensaje = errorServicio?.error?.meta?.detalle_mensaje || (errorServicio?.error?.errors ? Object.values(errorServicio.error.errors).flat().join(' | ') : 'Error');
        this.util.ShowMessage({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning' })
      })
    } catch (err) {
      loadingScreen.close();
    }
  }

  editTariff(row: any): void {

    const data: any[] = row.detail
    const metadata = row.metadata

    if (data.length === 0) {
      this.util.ShowMessage({ mensaje: "Debe agregar al menos un servicio a la tarifa.", tipo: "warning" })
      return
    }

    if (this.rol === "8" && data.length > 0) {
      const validate = data.find(r => !r["15_value"] || r["15_value"] < 0)
      if (validate) {
        this.util.ShowMessage({ mensaje: "Todos los servicios agregados deben de tener un costo mayor o igual a cero.", tipo: "warning" })
        return
      }
    }

    const loadingScreen = this.util.showLoadingScreen({ message: "Guardando tarifa ..." })
    try {
      const request = <PRI_MantenimientoTarifaRequest>{}

      const detalle: PRI_Tarifa_Det[] = []
      const recargo: PRI_Tarifa_Det_Recargo[] = []
      data.forEach(r => {

        if (r.statustable !== "E") {

          const item_detalle: PRI_Tarifa_Det = {
            codeinterno: r.codeinterno,
            ctar_codigo: row.ctar_codigo,
            dtar_codigo: r.statustable === 'I' ? r.codeinterno : r.dtar_codigo,
            serv_codigo: r.serv_codigo,
            profit_minimo: r.profit_minimo,
            statustable: r.statustable
          }
          detalle.push(item_detalle)


          const numbercolumns: any[] = []
          metadata.forEach(e => {
            const item_field = { field: e.field.input }
            numbercolumns.push(item_field)
          })

          numbercolumns.forEach(e => {

            const codigo = e.field.split('_')[0]

            const item_recargo: PRI_Tarifa_Det_Recargo = {
              rtar_codigo: r[codigo + '_codigo'],
              dtar_codigo: r.statustable === 'I' ? r.codeinterno : r.dtar_codigo,
              reco_codigo: codigo,
              rtar_valueventa: r[codigo + '_value'],
              serv_codigo: '1',
              rtar_valuedescripcion: r[codigo + '_label'],
              rtar_codigointerno: r[codigo + '_codigointerno'],
              tipo_codmnd: r[codigo + '_tipomoneda']

            }
            recargo.push(item_recargo)

          })
        }
      })

      const cabecera: PRI_Tarifa_Cab[] = []
      const item: PRI_Tarifa_Cab = {
        ctar_codigo: row.ctar_codigo,
        ctar_descripcion_spa: row.ctar_descripcion_spa,
        cons_codrgm: row.cons_codrgm,
        cons_codvia: row.cons_codvia,
        tipo_codmnd: row.tipo_codmnd,
        ctar_vigentedesde: row.ctar_vigentedesde,
        ctar_vigentehasta: row.ctar_vigentehasta,
        cons_codtco: row.cons_codtco,
        ctar_profitlocal: row.ctar_profitlocal,
        ctar_observacion: row.ctar_observacion,
        ctar_codigopadre: row.ctar_codigopadre,
        ctar_estado: row.ctar_estado,
        ctar_matriz: false,
        empr_codigo: 1,
        sucr_codigo: 1,
        tipo_codtar: row.tipo_codtar,
        tipo_codtpr: row.tipo_codtpr,
        cons_codfle: row.cons_codfle,
        entc_codigo: row.entc_codigo,
        tipo_codctr: row.tipo_codctr ?? null,
        puer_codigo: row.puer_codigo,
        codeinterno: 1,
        statustable: 'U',//row.statustable,
        usuario: this.storage.get('usuario')
      }
      cabecera.push(item)

      request.cabecera = cabecera
      request.detalle = detalle
      request.recargo = recargo

      this.servPricing.PRI_MantenimientoTarifa(request).subscribe(response => {
        if (response.datos.status === 200) {
          loadingScreen.close();
          this.util.ShowMessage({ titulo: 'SUCCESSFUL', mensaje: "Operación realizada con exito.", tipo: 'ok', autocerrar: false })
          this.search()
        }
      }, (errorServicio) => {
        loadingScreen.close();
        const mensaje = errorServicio?.error?.meta?.detalle_mensaje || (errorServicio?.error?.errors ? Object.values(errorServicio.error.errors).flat().join(' | ') : 'Error');
        this.util.ShowMessage({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning' })
      })
    } catch (err) {
      loadingScreen.close();
    }

  }

  enableDisableRow(row: any) {

    const request = <PRI_ActivarDesactivarTarifaRequest>{}
    request.ctar_codigo = row.ctar_codigo
    request.ctar_estado = row.ctar_estado === true ? false : true
    request.usuario = this.storage.get("usuario")

    this.servPricing.PRI_ActivarDesactivarTarifa(request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: 'SUCCESSFUL', mensaje: "Operación realizada con exito.", tipo: 'ok' })
        this.search()
      }
    }, (errorServicio) => {
      this.util.ShowMessage({ titulo: 'ERROR', mensaje: "Ocurrio un evento inesperado.", tipo: 'error' })
    })

  }



  exportarexcel(rowgeneral) {

    if (this.datatablaTarifa.length == 0) {
      this.util.MessageDialog({ titulo: "ERROR", mensaje: "No hay campos para exportar", icono: "pi pi-exclamation-triangle", tipo: "warning" });
      return;
    }
    let nuevadata = []
    rowgeneral.detail.forEach(row => {
      //   const {
      //     operacion, direccion_ip, nombre_maquina, nombre_aplicacion,
      //     usuario_sql, usuario_aplicacion, fecha_modificacion,
      //     tipo_ov, codigo_ov, item, tipo_servicio, codigo_servicio,
      //     origen_servicio, cantidad, precio_unitario, importe_ingreso, importe_egreso,
      //     modeda, codigo_moneda, precio_sugerido,
      //     tipo_entidad, codigo_entidad, codigo_tarifa,
      //     base_calculo, codigo_base_calculo, exonerado, change_control,
      //     documento, codido_documento, serie_documento, numero_documento,
      //     codigo_cuenta, fecha_operacion, codigo_empresa,
      //     usuario_creo, fecha_crea, usuario_modifica, fecha_modifica
      //   } = row;
      var newItem: any[] = []


      var newItemy: any = {};
      var index = 0
      rowgeneral.metadata.forEach(element => {

        newItemy[element.header.title] = row[element.field.output];
        index++;
        // const newItemX = {
        //   titulo : element.field.output,
        //   value: "12"
        //  // "Operacion": operacion,
        //   // "Direccion IP": direccion_ip,
        //   // "Nombre Maquina": nombre_maquina,
        //   // "Nombre Aplicacion": nombre_aplicacion,
        //   // "Usuario SQL": usuario_sql,
        //   // "Usuario Aplicacion": usuario_aplicacion,
        //   // "Fecha Modificacion": this.util.formatearfecha(fecha_modificacion, 'dd/mm/yyyy'),
        //   // "Tipo OV": tipo_ov,
        //   // "Codigo OV": codigo_ov,
        //   // "Item": item,
        //   // "Tipo Servico": tipo_servicio,
        //   // "Codigo Servicio": codigo_servicio,
        //   // "Origen Servicio": origen_servicio,
        //   // "Cantidad": cantidad,
        //   // "Precio Unitario": precio_unitario,
        //   // "Importe Ingreso": importe_ingreso,
        //   // "Importe Egreso": importe_egreso,
        //   // "Modeda": modeda,
        //   // "Codigo Moneda": codigo_moneda,
        //   // "Precio Sugerido": precio_sugerido,
        //   // "Tipo Entidad": tipo_entidad,
        //   // "Codigo Entidad": codigo_entidad,
        //   // "Codigo Tarifa": codigo_tarifa,
        //   // "Base Calculo": base_calculo,
        //   // "Codigo Base Calculo": codigo_base_calculo,
        //   // "Exonerado": exonerado,
        //   // "Change Control": change_control,
        //   // "Documento": documento,
        //   // "Codido Documento": codido_documento,
        //   // "Serie Documento": serie_documento,
        //   // "Numero Documento": numero_documento,
        //   // "Codigo Cuenta": codigo_cuenta,
        //   // "Fecha Operacion": this.util.formatearfecha(fecha_operacion, 'dd/mm/yyyy'),
        //   // "Codigo Empresa": codigo_empresa,
        //   // "Usuario Creo": usuario_creo,
        //   // "Fecha Crea": this.util.formatearfecha(fecha_crea, 'dd/mm/yyyy'),
        //   // "Usuario Modifica": usuario_modifica,
        //   // "Fecha Modifica": this.util.formatearfecha(fecha_modifica, 'dd/mm/yyyy'),
        // };
        // newItem.push(newItemX);
      });
      nuevadata.push(newItemy);
    });

    const data = [{ data: nuevadata, cabeceras: [] }]
    this.util.ExportarExcel(data, 'AUDITORÍA SERVICIOS CHANGE CONTROL.xlsx')
  }


  popUpProfitMasivo: boolean
  listadetalletarfia: any


  listMoneda: dropdownItems[] = [

    { label: "USD", value: "002" },
    { label: "POR", value: "004" },

  ]


  verpopupprofit(row) {
    this.popUpProfitMasivo = true

    this.listadetalletarfia = row
  }


  asignarprofitmasivo() {


    let fila = this.listadetalletarfia.detail

    let profit = this.groupprofit.value.profit
    let tipomoneda = this.groupprofit.value.tipoprofitmoneda
    let montoventa = 0

    const numbercolumns: any[] = []

    //  metadata.forEach(e => {
    //     const item_field = { field: e.field.input }
    //     numbercolumns.push(item_field)
    //   })

    console.log(tipomoneda)
    fila.forEach(item => {

      let costo = item['15_value']
      item['23_tipomoneda'] = '002';
      item['23_value'] = profit;
      item['16_tipomoneda'] = '002';


      let monedacosto = item["15_tipomoneda"]
      let costoconvertido = 0
      if (monedacosto == '001') {
        costoconvertido = Number(costo) / Number(this.tipoCambio.venta)
        // profitfinal = Number(profit) * Number(this.tipoCambio.venta)
      } else {
        costoconvertido = costo
      }


      if (tipomoneda == '004') {

        let profitconvertido = (Number(costoconvertido) * Number(profit)) / 100
        item['23_value'] = profitconvertido.toFixed(0);
        montoventa = Number(profitconvertido?.toFixed(0)) + Number(costoconvertido)
      } else {
        let profitfinal = 0
        montoventa = Number(costoconvertido) + Number(profit);
      }
      item['16_value'] = montoventa.toFixed(0)
      item['16_tipomonto'] = "V";


      item["statustable"] = item["statustable"] == 'E' ? 'U' : item["statustable"]

    });



    this.popUpProfitMasivo = false
  }


  SalirProfit() {
    this.popUpProfitMasivo = false
  }


  popupObservaciones: boolean
  listacabecera: any
  groupadicionales: FormGroup

  public viewobservaciones(row) {

    let values = this.groupadicionales.value

    // values['observaciones'].setValue('')
    this.groupadicionales.get('observaciones')?.setValue('');
    this.popupObservaciones = true
    this.listacabecera = row

    this.groupadicionales.get('observaciones')?.setValue(row.ctar_observacion);

  }

  procesarobservaciones() {

    this.listacabecera.ctar_observacion = this.groupadicionales.value.observaciones
    this.listacabecera.statustable = this.listacabecera.statustable == "E" ? 'U' : 'I'
    this.viewobservacionsalir()
  }

  public viewobservacionsalir() {
    this.popupObservaciones = false
    this.listacabecera = []
    this.groupadicionales.get('observaciones')?.setValue('');



  }


  handleInputChange() {


  }

}
